import { formatUserName, getMimicUser, stopMimic } from '../../services/helper';

export const MimicHeader = () => {
  const currentUser = getMimicUser();

  return currentUser !== null ? (
    <div
      className="mimic-header text-light py-1 text-center"
      style={{ zIndex: 1020, position: 'sticky', top: '0', backgroundColor: '#b81f69' }}
    >
      <div>
        You are logged in as <strong className="text-light">{formatUserName(currentUser)}</strong>.
        <button
          className="btn btn-link text-light ms-1 p-0"
          onClick={stopMimic}
        >
          Click here to return to your own login.
        </button>
      </div>
    </div>
  ) : null;
};
